import React from "react";
import { HamburgerIcon, EjectTipIcon } from "../../../Icons";

export function useMicroPipetteTooltip(props) {
  const hamburgerButtonRef = React.useRef(null);

  // Callback ref to handle when the hamburger button element is set
  const setHamburgerButtonElement = React.useCallback(
    (element) => {
      if (element && hamburgerButtonRef.current !== element) {
        hamburgerButtonRef.current = element;
        // Pass the ref to parent component if callback provided
        if (props?.onSetHamburgerButtonRef) {
          props.onSetHamburgerButtonRef(hamburgerButtonRef);
        }
      }
    },
    [props?.onSetHamburgerButtonRef]
  );

  function getButtonList(props) {
    const buttonList = [];
    if (props.showMoveMenu) {
      buttonList.push({
        onClick: props.openMoveMenu,
        image: HamburgerIcon,
        buttonRef: setHamburgerButtonElement,
      });
    }

    if (props.onRemoveTip) {
      buttonList.push({
        onClick: props.onRemoveTip,
        image: EjectTipIcon,
        altText: "Eject Tip",
      });
    }

    buttonList.push({
      onClick: props.openVolumeModal,
      label: props.volume + " µL",
    });

    return buttonList;
  }

  return { getButtonList };
}
